const hero = [
  require('assets/images/home/hero/ai1-01.png'),
  require('assets/images/home/hero/AllIsometricAug-25.jpg'),
  require('assets/images/home/hero/AllIsometricJune1b-20.jpg'),
  require('assets/images/home/hero/blue-motherboard-closeup-2021-08-26-17-53-00-utc.jpg'),
  require('assets/images/home/hero/computer-motherboard-with-cpu-circuit-board-syste-2021-08-26-16-56-57-utc.jpg'),
  require('assets/images/home/hero/cpu-central-processor-unit-chip-chip-on-circuit-b-2022-10-19-05-05-54-utc.jpg'),
  require('assets/images/home/hero/finger-touching-ai-technology-future-cyberspace-2022-11-08-03-14-42-utc.jpg'),
  require('assets/images/home/hero/global-strategy-and-communications-2021-08-26-22-30-02-utc.jpg'),
  require('assets/images/home/hero/human-like-robot-and-artificial-intelligence-2022-01-06-00-25-53-utc.jpg'),
  require('assets/images/home/hero/motherboard-of-a-personal-computer-processor-clos-2022-11-06-22-43-40-utc.jpg'),
  require('assets/images/home/hero/neon-ai-on-a-keyboard-2022-09-16-09-03-37-utc.jpg'),
  require('assets/images/home/hero/professional-business-meeting-data-on-screen-2022-11-14-06-39-12-utc.jpg'),
  require('assets/images/home/hero/robot-s-hand-holding-an-artificial-intelligence-co-2021-12-09-15-29-49-utc.jpg'),
  require('assets/images/home/hero/server-room-interior-in-datacenter-3d-render-2022-10-26-06-26-19-utc.jpg'),
  require('assets/images/home/hero/university-student-using-modern-technology-to-lear-2022-11-16-17-22-58-utc.jpg'),
  require('assets/images/home/hero/working-on-a-laptop-2022-09-16-08-14-56-utc.jpg'),
]

export default hero;
